export const BaseURL = {
  BASE_URL: `${process.env.REACT_APP_AUTH_BASE_URL}/api/v1/`,
};

export const API_CONSTANTS = {
  GET_OTP: `${BaseURL.BASE_URL}admin/user/send-otp`,
  VERIFY_OTP: `${BaseURL.BASE_URL}admin/user/verify-otp`,
  RESEND_OTP: `${BaseURL.BASE_URL}admin/user/send-otp?type=resend`,
  LOGOUT: `${BaseURL.BASE_URL}admin/user/logout`,
  REFRESH_TOKEN: `${BaseURL.BASE_URL}v1/refresh_token`,
  GET_USER_NEW: `${BaseURL.BASE_URL}admin/user`,
  GET_USER: `${BaseURL.BASE_URL}admin/userManagement`,
  MALL: `${BaseURL.BASE_URL}admin/mall`,
  STORE: `${BaseURL.BASE_URL}admin/stores`,
  CATEGORY: `${BaseURL.BASE_URL}app/category-list`,
  MEDIA_UPLOAD: `${BaseURL.BASE_URL}file/upload`,
  CREATE_MALL_BANNER: `${BaseURL.BASE_URL}admin/file`,
  // Banner_Management segment (D-02) — never the shared /admin/export
  // (Analytics_and_Reporting), which would log out a banner-only admin.
  BANNER: `${BaseURL.BASE_URL}admin/banner`,
  EMINITIES: `${BaseURL.BASE_URL}emities`,
  SUPPORT_DETAIL: `${BaseURL.BASE_URL}admin/supportDetail`,
  EVENT: `${BaseURL.BASE_URL}admin/events`,
  GAME: `${BaseURL.BASE_URL}admin/game`,
  TIER: `${BaseURL.BASE_URL}admin/tier`,
  VOUCHER: `${BaseURL.BASE_URL}admin/voucher`,
  OFFER: `${BaseURL.BASE_URL}admin/offers`,
  BILL: `${BaseURL.BASE_URL}admin/bill`,
  CUSTOMER: `${BaseURL.BASE_URL}admin/customer`,
  REPORT: `${BaseURL.BASE_URL}admin/reports`,
  NOTIFICATION: `${BaseURL.BASE_URL}admin/notification`,
  FEEDBACK: `${BaseURL.BASE_URL}admin/feedback`,
  MEDIA_BILL_UPLOAD: `${BaseURL.BASE_URL}file/upload-bill`,
  EXPORT: `${BaseURL.BASE_URL}admin/export`,
  GAMIFICATION: `${BaseURL.BASE_URL}admin/gamification`,
  // App_Settings module (D-07 backend migration 1787000000004) — a
  // different segment would log a non-su admin out.
  APP_SETTINGS: `${BaseURL.BASE_URL}admin/appSettings`,
};


export const VOUCHER_PASSWORD ={
  VOUCHER_PASSWORD:`${process.env.REACT_APP_PASSWORD_VOUCHER_CREDENTIALS}`
}